<template>
  <div id="app">
    <el-container class="main">
      <el-header>
        <a v-if="pid" :href="'/detail/'+pid+'?count='+pcount" style="float:left;"><i class="icon-back"></i></a>
        <a v-else href="/" style="float:left;"><i class="icon-back"></i></a>
        <span>{{'IPFS独享矿机计算器'|langTranslation}}</span>
      </el-header>
      <el-main>

        <div class="box">
          <div class="info" v-if="info">
            <div class="info-date">
              データ更新日：<span class="highlight">{{info.today}}</span>
            </div>
            <div class="info-detail">
              <ul>
                <li><span>{{'当前全网总算力'|langTranslation}}: </span> <em class="highlight">{{info.qwzsl[0]}} {{info.qwzsl[1]|langTranslation}}</em></li>
                <li><span>{{'当前平均产出'|langTranslation}}: </span> <em class="highlight">{{info.pjcc[0]}} {{info.pjcc[1]|langTranslation}}</em></li>
                <li><span>{{'当前质押量'|langTranslation}}: </span> <em class="highlight">{{info.zyl[0]}} {{info.zyl[1]|langTranslation}}</em></li>
                <li><span>{{'全网算力增速'|langTranslation}}: </span> <em class="highlight">{{info.slzs[0]}} {{info.slzs[1]|langTranslation}}</em></li>
              </ul>

            </div>
          </div>

          <el-form :inline="true" :label-position="labelPosition" label-width="80px" >
            <el-form-item :label="'开挖时间'|langTranslation">
              <el-date-picker
                  type="date"
                  v-model="form.start_date"
                  :placeholder="'选择日期'|langTranslation">
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="'封装速度'|langTranslation" class="power-pre">
              <div class="power-pre-day"><span>{{form.power_per_day|toFixed(2)}}</span><em>{{'TB/日'|langTranslation}}</em></div>
              <div class="power-pre-set-box">
                <el-button icon="el-icon-minus" size="mini" @click="addPowerPerDay(-0.01)"></el-button>
                <el-slider :max="power_per_max" :min="power_per_min" :step="0.01" :show-tooltip="false" v-model="form.power_per_day">
                </el-slider>
                <el-button icon="el-icon-plus" size="mini" @click="addPowerPerDay(0.01)"></el-button>
              </div>

            </el-form-item>
            <el-form-item :label="'存储空间'|langTranslation">
              <el-input :placeholder="'存储空间'|langTranslation" v-model="form.total_power">
                <template slot="append">TB</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="'产品期限'|langTranslation">
              <el-select :placeholder="'产品期限'|langTranslation" v-model="form.day">
                <el-option key="365" label="365日" value="365"></el-option>
                <el-option key="540" label="540日" value="540"></el-option>
                <el-option key="1080" label="1080日" value="1080"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="'投入成本'|langTranslation">
              <el-input :placeholder="'投入成本'|langTranslation" v-model="form.cost" @blur="changeCost()" >
                <template slot="append">JPY</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="'最新币价'|langTranslation">
              <el-input :placeholder="'最新币价'|langTranslation" v-model="form.price" >
                <template slot="append">USDT</template>
              </el-input>
            </el-form-item>
          </el-form>
        <el-form>
          <el-form-item>
            <el-button type="primary" class="btn-submit" @click="calc()" >{{'开始计算'|langTranslation}}</el-button>
          </el-form-item>
        </el-form>

          <div v-if="sum_list.length">

            <vxe-table
                :data="sum_list"
                border
                :row-style="rowStyle"
                :cell-style="cellStyle"
            >
              <vxe-table-column
                  fixed="left"
                  field="title"
                  label=""
                  width="150">
                <template v-slot="scope">
                  <span v-html="scope.row.title"></span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                  prop="full"
                  align="center"
                  min-width="150">
                <template  v-slot:header>
                  <span>{{'封装满天数'|langTranslation}} <br/>{{full_date}}{{'天'|langTranslation}}</span>
                </template>
                <template v-slot="scope">
                  <template v-if="scope.row.jcc">{{scope.row.full|toFil(price)}} FIL<br/>
                    <em>≈ {{scope.row.full|toFixed(2)}} USDT</em>
                  </template>
                  <template v-else-if="scope.row.action">
                    <el-link style="display: none" type="primary" @click="showTableDate=full_date">{{'查看详细数据'|langTranslation}}</el-link>
                  </template>
                  <template v-else><span :class="{highlight:scope.row.qkcc}">{{scope.row.full|toFixed(4)}} FIL</span><br/>
                    <em>≈ {{scope.row.full|toUSDT(price)}} USDT</em>
                  </template>

                </template>
              </vxe-table-column>
              <vxe-table-column
                  prop="break_even"
                  align="center"
                  min-width="150">
                <template  v-slot:header>
                  <span v-if="break_even_date>0">{{'产出平衡'|langTranslation}} <br/>{{break_even_date}}{{'天'|langTranslation}}</span>
                  <span v-else>{{'无法平衡'|langTranslation}}</span>
                </template>
                <template v-slot="scope">
                  <template v-if="scope.row.jcc">{{scope.row.break_even|toFil(price)}} FIL<br/>
                    <em>≈ {{scope.row.break_even|toFixed(2)}} USDT</em>
                  </template>
                  <template v-else-if="scope.row.action">
                    <el-link style="display: none" type="primary" @click="showTableDate=break_even_date">{{'查看详细数据'|langTranslation}}</el-link>
                  </template>
                  <template v-else><span :class="{highlight:scope.row.qkcc}">{{scope.row.break_even|toFixed(4)}} FIL</span><br/>
                    <em>≈ {{scope.row.break_even|toUSDT(price)}} USDT</em>
                  </template>
                </template>
              </vxe-table-column>
              <vxe-table-column
                  prop="last"
                  align="center"
                  min-width="150">
                <template  v-slot:header>
                  <span>{{'挖矿'|langTranslation}} <br/>{{last_date}}{{'天'|langTranslation}}</span>
                </template>
                <template v-slot="scope">
                  <template v-if="scope.row.jcc">{{scope.row.last|toFil(price)}} FIL<br/>
                    <em>≈ {{scope.row.last|toFixed(2)}} USDT</em>
                  </template>
                  <template v-else-if="scope.row.action">
                    <el-link style="display: none" type="primary" @click="showTableDate=last_date">{{'查看详细数据'|langTranslation}}</el-link>
                  </template>
                  <template v-else><span :class="{highlight:scope.row.qkcc}">{{scope.row.last|toFixed(4)}} FIL</span><br/>
                    <em>≈ {{scope.row.last|toUSDT(price)}} USDT</em>
                  </template>
                </template>
              </vxe-table-column>

            </vxe-table>
          </div>

        </div>
      </el-main>
      <el-footer height="auto">
        <div class="tooltip">
          <p>注意事項：</p>
          <p>１.当計算機で算出される数値は<span class="highlight">参考値</span>であり、実際の数値と乖離する場合があります。算出されている数値は参考程度に捉えてください。</p>
          <p>2.上記の計算には、<span class="highlight">サービス手数料</span>や<span class="highlight">Gas料金</span>は考慮されていません。</p>
          <p>3.設定されたシーリング速度とストレージ容量に基づいてマイニングを行うには相応するプロセスがあります。</p>

        </div>
      </el-footer>
      <p>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;</p>
    </el-container>


    <el-dialog title="" :visible.sync="dialogVisible" width="90%" top="20px" >


      <vxe-table :data="tabelRows"
                 :max-height="dialogHeight"
                 show-overflow
                 show-header-overflow
                 align="center"
                 :scroll-x="{gt: 10}"
                 :scroll-y="{gt: 100}"
      >
        <vxe-table-column property="index" :title="'天数'|langTranslation" width="80" fixed="left">
          <template v-slot="scope">
            {{scope.seq}} {{'天'|langTranslation}}
          </template>
        </vxe-table-column>
        <vxe-table-column property="single_reward"  min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日单T奖励')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.single_reward|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="single_pledge" :title="langTranslation('当日单T质押')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日单T质押')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.single_pledge|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="add_power" :title="langTranslation('当日新增算力')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日新增算力')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.add_power|toFixed(4)}} T
          </template>
        </vxe-table-column>
        <vxe-table-column property="single_pledge" :title="langTranslation('新增扇区有效天数')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('新增扇区有效天数')"></span>
          </template>
          <template v-slot="scope">
            540 {{'天'|langTranslation}}
          </template>
        </vxe-table-column>
        <vxe-table-column property="valid_power" :title="langTranslation('当日有效算力')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日有效算力')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.valid_power|toFixed(4)}} T
          </template>
        </vxe-table-column>
        <vxe-table-column property="add_pledge" :title="langTranslation('当日新增扇区质押量')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日新增扇区质押量')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.add_pledge|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="reward" :title="langTranslation('当日区块奖励')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日区块奖励')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.reward|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="freed_reward" :title="langTranslation('当日区块奖励释放')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('当日区块奖励释放')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.freed_reward|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="grand_pledge" :title="langTranslation('累计扇区质押')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('累计扇区质押')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.grand_pledge|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="grand_reward" :title="langTranslation('累计区块奖励')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('累计区块奖励')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.grand_reward|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="lock_reward" :title="langTranslation('累计待释放区块奖励')" min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('累计待释放区块奖励')"></span>
          </template>
          <template v-slot="scope">
            {{scope.row.lock_reward|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
        <vxe-table-column property="grand_freed_reward" :title="langTranslation('累计已释放区块奖励')" show-header-overflow min-width="200">
          <template v-slot:header>
            <span v-html="langTranslation('累计已释放区块奖励')"></span>
          </template>
          <template  v-slot="scope">
            {{scope.row.grand_freed_reward|toFixed(4)}} FIL
          </template>
        </vxe-table-column>
      </vxe-table>

    </el-dialog>

    <el-dialog :visible.sync="showLoginDialog" width="320px">
        <h1 class="login-logo"></h1>
      <el-form :model="loginInfo" :rules="loginRules" ref="loginForm" label-width="0" @validate="validated">
          <el-form-item prop="account" ref="fi_account" :error="loginError.account">
            <el-input class="text" v-model="loginInfo.account" ref="account" :placeholder="'输入手机号码'|langTranslation">

            </el-input>
          </el-form-item>
          <el-form-item prop="passwd" ref="fi_passwd">
            <el-input type="password" class="text" v-model="loginInfo.passwd" ref="account" :placeholder="'输入密码'|langTranslation">
            </el-input>
          </el-form-item>
        </el-form>
      <div>
        <el-button type="primary" class="btn-submit" @click="login()" >{{'登录'|langTranslation}}</el-button>
        <el-link href="https://www.rrm.jp" class="button02">新規の方はこちら</el-link>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import date from './common/date'
import {getInfo,calc} from './common/api'
import Big from 'big.js' ;
import 'el-bigdata-table'
import Vue from 'vue';

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import common from './common/common'

const langTranslation = common.langTranslation;

Vue.use(VXETable)

export default {
  name: 'app',
  data() {
    let query = this.$route.query;
    return {
      labelPosition: 'top',
      pid:query.pid,
      pcount:query.c,
      form: {
        start_date: query.start_date || date.format(new Date, 'yyyy-MM-dd'),
        cost: query.cost || 1000,
        init_power: query.init_power || 0,
        price: query.price || 0,
        day:'540',
        power_per_day: (query.power_per_day || 1)*1,
        total_power: "total_power" in query ?query.total_power : 1,
        single_pledge: query.single_pledge || 0
      },

      loginInfo:{
        account:'',
        passwd:''
      },
      loginRules:{
        account: [
          { required: true, message: langTranslation('请输入手机号码'), trigger: 'blur' },
        ],
        passwd: [
          { required: true, message: langTranslation('请输入密码'), trigger: 'blur' },
        ],
      },
      loginError:{
        account:'',
      },

      power_per_max:Math.max(query.power_per_day||0,40),
      power_per_min:0,
      info:null,
      list:[],
      sum_list:[],
      break_even_date:0,
      last_date:0,
      full_date:0,
      cost_usdt:0,
      exchange_rate:0,
      price:0,
      showTableDate:0,
      showLoginDialog:false,
      dialogHeight:window.innerHeight * 0.9 - 150
    }
  },
  computed:{
    tabelRows(){
      let list = this.showTableDate>0?this.list.slice(0,this.showTableDate):[];
      return list;
    },
    dialogVisible:{
      get(){
        return this.showTableDate>0

      },
      set(){
        this.showTableDate = 0;
      }
    }
  },
  created() {
    let that = this;
    window.onresize = function(){
      that.dialogHeight = window.innerHeight * 0.9 - 150;
    }
    this.init()
  },
  filters:{
    toFixed(d,f=4){
      return Big(d).toFixed(f);
    },
    toUSDT(d,price,f=2){
      return Big(d).times(price).toFixed(f)
    },
    toFil(d,price,f=4){
      return Big(d).div(price).toFixed(f)
    }
  },
  components: {},
  methods: {
    init() {
      getInfo().then(json=>{
        this.info = json.data;
        this.form.price=json.data.zxbj;
        this.form.single_pledge = json.data.zyl[0]
      })
      this.changeCost()
    },
    langTranslation:common.langTranslation,
    changeCost(){
      this.form.cost = this.form.cost.toString().replace(/[^\d.]/g,'').replace(/\d{1,3}(?=(\d{3})+$)/g,'$&,')
    },
    cellStyle({ row, rowIndex, column, columnIndex }){
      if(columnIndex==0){
        if(!row.jcc){
          return {
            color: '#fff',
            fontWeight:'bold',
          }
        }else{
          return {
            fontWeight:'bold',
          }
        }

      }
    },
    rowStyle({ row, rowIndex }){
      if(row.jcc){
        return {
          backgroundColor: '#FDD205',
          color:'#4A4A4A'
        }
      }
    },
    calc(){
      if(!window.USER_INFO){
        this.showLoginDialog = true;
        return false;
      }
      if(this.calcing) return ;
      this.calcing = true;
      let tran_data = (it) => {

        return it?{
          zy: it.grand_pledge,
          cc: it.grand_reward,
          sf: it.grand_freed_reward,
          dsf: it.lock_reward,
          jcc: Big(it.grand_reward).times(this.price).sub(this.cost_usdt).toFixed(8)
        }:{
          zy: 0,
          cc: 0,
          sf: 0,
          dsf: 0,
          jcc: 0
        }
      };
      let form = {
        ...this.form
      }
      form.cost = form.cost.replace(/,/g,'');
      calc(form).then(json=>{
        this.calcing = false;

        this.list = json.data.list;
        this.full_date = json.data.full_date;
        this.break_even_date = json.data.break_even_date;
        this.last_date = json.data.list.length;
        this.cost_usdt = json.data.cost_usdt;
        this.exchange_rate = json.data.exchange_rate;
        this.price = json.data.price;

        let full = tran_data(json.data.list[json.data.full_date - 1])
        let brewk_even = tran_data(json.data.list[json.data.break_even_date - 1])
        let last = tran_data(json.data.list[json.data.list.length-1]);

        this.sum_list = [
          {title: langTranslation('扇区质押'), full: full.zy, break_even: brewk_even.zy, last: last.zy},
          {title: langTranslation('区块奖励产出'),qkcc:1, full: full.cc, break_even: brewk_even.cc, last: last.cc},
          {title: langTranslation('已释放区块奖励'), full: full.sf, break_even: brewk_even.sf, last: last.sf},
          {title: langTranslation('待释放区块奖励'), full: full.dsf, break_even: brewk_even.dsf, last: last.dsf},
          {title: langTranslation('净产出'),jcc:1, full: full.jcc, break_even: brewk_even.jcc, last: last.jcc},
          {title:'',action:1}
        ];
        //console.log(json);
      }).catch(()=>{
        this.calcing = false;
      })
    },
    login(){
      this.$refs.loginForm.validate(rs=>{
        if(!rs) {
          return ;
        }
        common.login(this.loginInfo.account,this.loginInfo.passwd).then(json=>{
          if(json.state){
            this.$message(langTranslation('登录成功'))
            window.USER_INFO = json.data;
            this.showLoginDialog = false;
            this.calc();
          }else{
            this.loginError.account = '';
            this.loginError.account = json.message;
          }
        })

      })
    },
    validated(field,rs,msg){
      this.loginError[field]=msg;
    },
    addPowerPerDay(add){
      let p = this.form.power_per_day + add;

      this.form.power_per_day = Math.min(Math.max(p, this.power_per_min), this.power_per_max)
    }
  }
}
</script>
<style lang="scss">

</style>
